import { Cookies } from 'react-cookie';
import {
    TYPE_RESET,
    TYPE_FOCUS,
    TYPE_DOWNLOADED,
    TYPES_DOWNLOADED,
    TYPES_PENDING,
    TYPES_FAILED,
    TYPE_FAILED,
    TYPE_POSTING,
    TYPE_EDITING,
    TYPE_DELETING,
    TYPES_RESET,
    TYPE_DELETED,
    TYPE_PICTURE_UPLOADING,
    TYPE_PICTURE_FAILED,
    TYPE_PICTURE_UPLOADED,
    TYPE_PICTURE_DELETING,
} from './types';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';

const cookies = new Cookies();

// Action creators

export const resetTypeAction = () => {
    return { type: TYPE_RESET };
};

export const resetTypesAction = () => {
    return { type: TYPES_RESET };
};

export const typesPendingAction = () => {
    return { type: TYPES_PENDING };
};

export const typePostingAction = () => {
    return { type: TYPE_POSTING };
};

export const typeDeletedAction = (id) => {
    return {
        type: TYPE_DELETED,
        payload: id,
    };
};

export const typeDeletingAction = () => {
    return { type: TYPE_DELETING };
};

export const typeEditingAction = () => {
    return { type: TYPE_EDITING };
};

export const typesDownloadedAction = (types) => {
    return {
        type: TYPES_DOWNLOADED,
        payload: types,
    };
};

export const typeDownloadedAction = (type) => {
    return {
        type: TYPE_DOWNLOADED,
        payload: type,
    };
};

export const typeFocusAction = (type) => {
    return {
        type: TYPE_FOCUS,
        payload: type,
    };
};
export const uploadPictureAction = (picture) => {
    return {
        type: TYPE_PICTURE_UPLOADING,
        payload: picture,
    };
};

export const uploadPictureFailedAction = (error) => {
    return {
        type: TYPE_PICTURE_FAILED,
        payload: error.message,
    };
};

export const uploadPictureSucceedAction = (type) => {
    return {
        type: TYPE_PICTURE_UPLOADED,
        payload: type,
    };
};

export const deletePictureAction = () => {
    return {
        type: TYPE_PICTURE_DELETING,
    };
};

// Actions

export function resetType() {
    return (dispatch) => {
        dispatch(resetTypeAction());
    };
}

export function resetTypes() {
    return function (dispatch) {
        dispatch(resetTypesAction());
    };
}

export function getTypes(appId, lang) {
    return function (dispatch, getState) {
        dispatch(typesPendingAction());
        return APIService
            .getTypes(appId, cookies.get('token'), lang)
            .then(types => {
                dispatch(typesDownloadedAction(types));
            })
            .catch((error) => {
                dispatch(handleError(error, TYPES_FAILED));
            });
    };
}

export function fetchType(appId, typeId) {
    return function (dispatch, getState) {
        let types = getState().types.content;
        let type = types.find(function (type) {
            return type.id === typeId;
        });

        if (type) {
            return dispatch(typeFocusAction(type));
        } else {
            return dispatch(getType(appId, typeId));
        }
    };
}

export function getType(appId, typeId) {
    return function (dispatch) {
        dispatch(typesPendingAction());
        return APIService
            .getType(appId, typeId, cookies.get('token'))
            .then(type => {
                dispatch(typeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, TYPE_FAILED));
            });
    };
}

export function postType(appId, type, lang) {
    return function (dispatch) {
        dispatch(typePostingAction());
        return APIService
            .postType(appId, type, cookies.get('token'), lang)
            .then(type => {
                dispatch(typeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, TYPE_FAILED));
            });
    };
}

export function putType(appId, type, lang) {
    return function (dispatch) {
        dispatch(typeEditingAction());
        return APIService
            .putType(appId, type, cookies.get('token'), lang)
            .then(type => {
                dispatch(typeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, TYPE_FAILED));
            });
    };
}

export function deleteType(appId, typeId) {
    return function (dispatch) {
        dispatch(typeDeletingAction());
        return APIService
            .deleteType(appId, typeId, cookies.get('token'))
            .then(() => {
                dispatch(typeDeletedAction(typeId));
            })
            .catch((error) => {
                dispatch(handleError(error, TYPE_FAILED));
            });
    };
}

export function postTypePicture(appId, typeId, picture, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadPictureAction(picture));
        return APIService
            .postTypePicture(appId, typeId, picture, cookies.get('token'), onUploadProgress)
            .then(type => {
                dispatch(typeDownloadedAction(type));
                dispatch(uploadPictureSucceedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, TYPE_FAILED));
                dispatch(uploadPictureFailedAction(error));
            });
    };
}

export function deleteTypePicture(appId, typeId) {
    return function (dispatch) {
        dispatch(deletePictureAction());
        return APIService
            .deleteTypePicture(appId, typeId, cookies.get('token'))
            .then((type) => {
                dispatch(typeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, TYPE_FAILED));
            });
    };
}



// WEBPACK FOOTER //
// src/store/types/actions.js